import { createSlice } from "@reduxjs/toolkit";
import {
  addApiCases,
  createDynamicThunk,
} from "../../../../../service/requestHandler";

export const awsLiveDataAPI = createDynamicThunk(
  "awsLiveDataAPI",
  "/report/api/v1/architecture/getArchitectureComplianceTreeMap"
);

export const awsDataLastScannedAPI = createDynamicThunk(
  "awsDataLastScannedAPI",
  "/report/api/v1/architecture/getLastScanDateByAccountName"
);

export const azureLiveDataAPI = createDynamicThunk(
  "azureLiveDataAPI",
  "/api/v1/azureArchitectureDashboardController/getAzureArchitectureComplianceTreeMap"
);

export const Timelinechart = createDynamicThunk(
  "Timelinechart",
  "/report/api/v1/architecture/getResourcesActivityByAccountIdsAndServiceNames"
);

export const Metricschart = createDynamicThunk(
  "Metricschart",
  "/report/api/v1/architecture/getMetricDataByServiceNameAndAccountId"
);

export const atcMoreServiceFilterAPI = createDynamicThunk(
  "atcMoreServiceFilterAPI",
  "/report/api/v1/architecture/getTreeMapFilter",
);

export const aws3DDataAPI = createDynamicThunk(
  "aws3DDataAPI",
  "/api/v1/architectureCompliance/getAwsData"
);

export const initialState = {
  awsLiveDataAPIData: [],
  awsLiveDataAPILoading: false,
  awsDataLastScannedAPIData: [],
  awsDataLastScannedAPILoading: false,
  azureLiveDataAPIData: [],
  azureLiveDataAPILoading: false,
  TimelinechartData: [],
  TimelinechartLoading: false,
  MetricschartData: [],
  MetricschartLoading: false,
  atcMoreServiceFilterAPIData: [],
  atcMoreServiceFilterAPILoading: false,
  aws3DDataAPIData: [],
  aws3DDataAPILoading: false,
};

export const architectureSlice = createSlice({
  name: "architectureSlice",
  initialState,
  reducers: {
    resetarchitectureSlice: () => initialState,
    resetATCData: () => initialState,
  },
  extraReducers: (builder) => {
    addApiCases(builder, awsLiveDataAPI, "awsLiveDataAPIData");
    addApiCases(builder, awsDataLastScannedAPI, "awsDataLastScannedAPIData");
    addApiCases(builder, azureLiveDataAPI, "azureLiveDataAPIData");
    addApiCases(builder, Timelinechart, "TimelinechartData");
    addApiCases(builder, Metricschart, "MetricschartData");
    addApiCases(
      builder,
      atcMoreServiceFilterAPI,
      "atcMoreServiceFilterAPIData"
    );
    addApiCases(builder, aws3DDataAPI, "aws3DDataAPIData");
  },
});

export const { resetarchitectureSlice, resetATCData } =
  architectureSlice.actions;
export default architectureSlice.reducer;
